import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { DialogService, ToastService } from '@core';
import { MeterService } from '@feature/meter';
import { Observable } from 'rxjs';
import { filter, map, startWith, switchMap } from 'rxjs/operators';
import { GroupBaselineService } from '../data-access/group-baseline.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-group-baseline',
  templateUrl: './create-group-baseline.component.html',
  styleUrls: ['./create-group-baseline.component.scss'],
})
export class CreateGroupBaselineComponent implements OnInit {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  groupBaselineCtrl = new FormControl('');
  filteredGroupBaseline: Observable<any[]>;
  groupBaselines: any[] = [];
  allGroupBaseline: any[] = [];

  emails: string[] = [];
  emailCtrl = new FormControl('');

  @ViewChild('groupBaselineInput')
  groupBaselineInput!: ElementRef<HTMLInputElement>;

  formData = new FormGroup({
    name: new FormControl('', Validators.required),
    setpoint_day: new FormControl<number | null>(null),
    setpoint_month: new FormControl<number | null>(null),
    sensor_id: new FormControl(),
  });

  constructor(
    private rest: GroupBaselineService,
    private meterService: MeterService,
    public dialogServcie: DialogService,
    public toast: ToastService,
    private matRef: MatDialogRef<CreateGroupBaselineComponent>,
  ) {
    this.filteredGroupBaseline = this.groupBaselineCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) =>
        fruit ? this._filter(fruit) : this.allGroupBaseline.slice(),
      ),
    );
  }

  ngOnInit(): void {
    this.loadMeters();
  }

  loadMeters() {
    this.dialogServcie
      .withLoading(
        this.meterService.getMeters({
          sensor_type: 'energy',
          sensor_module: 'EMS',
          // get_mdb: true,
        }),
      )
      .subscribe({
        next: (res) => {
          try {
            if (res.meta.response_code == 20000) {
              this.allGroupBaseline = res.meta.response_data.map(
                (meter: any) => {
                  return {
                    ...meter,
                    id: meter.id,
                    // name: meter.meter_name
                  };
                },
              );
              this.groupBaselineCtrl.patchValue('');
            } else {
              this.toast.error('โหลดข้อมูลไม่สำเร็จ');
            }
          } catch (error) {
            console.error(`ERROR : [api_get_meter_overview] `, error);
          }
        },
        error: (e) => {
          console.error(e);
          this.toast.error('โหลดข้อมูลไม่สำเร็จ');
        },
      });
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.groupBaselines.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.groupBaselineCtrl.setValue(null);
  }

  remove(groupBaseline: any): void {
    const index = this.groupBaselines.indexOf(groupBaseline);
    if (index >= 0) {
      this.groupBaselines.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    // this.groupBaseline.push(event.option.viewValue);
    this.groupBaselines.push(event.option.value);
    this.groupBaselineInput.nativeElement.value = '';
    this.groupBaselineCtrl.setValue(null);
  }

  private _filter(value: any): string[] {
    let filterValue = '';
    if (value.name) {
      filterValue = value.name.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    return this.allGroupBaseline.filter((fruit) => {
      try {
        return fruit.name.toLowerCase().includes(filterValue);
      } catch (error) {
        return;
      }
    });
  }

  numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  confirm() {
    if (this.formData.valid) {
      this.dialogServcie
        .confirm({
          title: `ต้องการสร้าง Baseline หรือไม่`,
        })
        .pipe(
          filter(Boolean),
          switchMap(() => {
            let data: {
              name: string;
              setpoint_day?: number;
              setpoint_month?: number;
              sensor_id: any[];
              emails: string[];
            } = {
              name: this.formData.value.name || '',
              setpoint_day: Number(this.formData.value.setpoint_day!),
              setpoint_month: Number(this.formData.value.setpoint_month!),
              sensor_id: Array.from(
                new Set(this.groupBaselines.map((value) => value.id)),
              ),
              emails: this.emails,
            };

            return this.dialogServcie.withLoading(
              this.rest.createBaselineGroup(data),
            );
          }),
        )
        .subscribe({
          next: (res) => {
            if (res.meta.response_code === 20000) {
              this.toast.success('เพิ่มข้อมูลสำเร็จ');
              this.matRef.close(true);
            } else this.toast.error('เพิ่มข้อมูลสไม่สำเร็จ');
          },
          error: () => this.toast.error('เพิ่มข้อมูลสไม่สำเร็จ'),
        });
    }
  }

  onInput(event: any, controlName: string) {
    const value = event.target.value.replace(/[^0-9]/g, '');
    this.formData.get(controlName)?.setValue(value, { emitEvent: false });
  }

  addEmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    if (!value) {
      return;
    }

    if (!this.emails.includes(value)) {
      this.emails.push(value);
    }

    event.chipInput?.clear();
    this.emailCtrl.setValue('');
  }

  removeEmail(email: string): void {
    const index = this.emails.indexOf(email);

    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }
}
